import React from "react";
import { separate } from "../../Functions/NumberSeprator";
import FactorList from "../FactorList/FactorList";
import factor from "./Factor.module.css";

const Factor = ({ data, orderID}) => {
  let totalPrice = null;
  if (data !== undefined) {
    data.products.forEach((element) => {
      totalPrice = totalPrice + parseInt(element.price);
    });
  }
  let loadingHandler = null;
  if (data === undefined) {
    loadingHandler = <p>در حال دریافت اطلاعات</p>;
  } else {
    loadingHandler = (
      <div className={factor.factorHolder}>
        <h1 className={factor.title}>فاکتور</h1>
        <ul className={factor.factorList}>
          {data.products.map((item, index) => {
            return (
              <FactorList
                key={index}
                name={item.name}
                price={item.price}
                count={item.count}
                fee={item.product_fee}
              />
            );
          })}
          {data.decription === null ? null : (
            <li className={factor.desc}>
              <p>{data.decription}</p> توضیحات سفارش:
            </li>
          )}
        </ul>
        <div className={factor.total}>
          <h2 className={factor.totalPrice}>مجموع</h2>
          <h2 className={factor.price}>
            {separate(totalPrice)} <span className={factor.toman}>تومان</span>
          </h2>
        </div>
        {/* <div className={factor.editBtn}>
          <Button
            Value={"ویرایش فاکتور"}
            ClassBtn={"factor"}
            ClickHandler={() => history.push("/changefactor", orderID)}
          />
        </div> */}
      </div>
    );
  }

  return <>{loadingHandler}</>;
};

export default Factor;
